import { createAsyncThunk } from '@reduxjs/toolkit';
import notificationService from '../../../api/services/notification';

export const getAllNotifications = createAsyncThunk('notification/getAllNotifications', async page => {
  return await notificationService.getAllNotifications(page);
});

export const fetchNumOfUnreadNotifications = createAsyncThunk(
  'notifications/fetchNumOfUnreadNotifications',
  async () => {
    return await notificationService.getNumberOfUnreadNotifications();
  },
);

export const markNotificationsAsSeen = createAsyncThunk('notification/markNotificationsAsSeen', async () => {
  return await notificationService.markNotificationAsSeen();
});
